module.exports = __webpack_public_path__ + "static/media/video1.94a18a00.png";